export default __webpack_public_path__ + "static/media/lkw.4523415a.png";